import { useBreakpoints } from '../../../../../../bookings/util/useBreakpoints';
import {
  LinkTrackingData,
  SearchCardArea,
} from '../../../../../../common/AnalyticsContext/LinkTracking';
import { makePracticeBookNowUrl } from '../../../../../urls';
import { AppointmentsView, CallToAction, Content, CtaLink } from './Appointments.styles';
import { CtaLinkWithTapTarget } from './CtaLinkWithExperiment';

interface Props {
  trackingData: undefined | LinkTrackingData;
  practiceId: string;
  specialty: string;
}

const PACK_AND_PILL_PRACTICE_ID = '89976';

export const BookNow = ({ trackingData, practiceId, specialty }: Props) => {
  const breakpoints = useBreakpoints();
  const bookNowTracking = { ...trackingData, searchCardArea: SearchCardArea.REQUEST_APPOINTMENT };
  const url = makePracticeBookNowUrl(practiceId, specialty);

  return (
    <AppointmentsView>
      {practiceId !== PACK_AND_PILL_PRACTICE_ID && (
        <Content>
          The practice will contact you {!breakpoints.Small && 'to schedule your appointment'}
        </Content>
      )}
      {breakpoints.Small ? (
        <CtaLinkWithTapTarget to={url} trackingData={bookNowTracking}>
          <CallToAction>Book Now</CallToAction>
        </CtaLinkWithTapTarget>
      ) : (
        <CtaLink to={url} trackingData={bookNowTracking}>
          <CallToAction>Book Now</CallToAction>
        </CtaLink>
      )}
    </AppointmentsView>
  );
};
